var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"12"}},[_c('ek-table',{attrs:{"items":_vm.sellpoints,"columns":_vm.sellPointCols,"no_delete":""},on:{"details":_vm.goToDetails},scopedSlots:_vm._u([{key:"items.subscribeDate",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(value ? new Date(value).toLocaleDateString() : "_")+" ")]}},{key:"items.lastPaidDate",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(value ? new Date(value).toLocaleDateString() : "_")+" ")]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }